<div class="file-extension-container {{fileType}}" [ngClass]="{'mobile': device.isMobile}">
    <div class="content">{{fileExtension}}</div>
</div>